<div class="p-3 pt-2 rounded-4">
  <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0">
    <div class="p-3">Beneficiaries</div>
  </div>
  <div class="container-fluid">
    <div class="row bg-white p-2 pt-0">
      <div class="col-md-12 mt-4 mb-5">
        <div class="table-responsive">
          <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
            [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
          </ag-grid-angular>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #content let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Beneficiary Details</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  @if (selectedBeneficiary) {
    <div class="modal-body">
      <div class="row g-4">
        <!-- Sender Details -->
        <div class="col-md-6">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-header bg-light fw-bold">
              Sender Details
            </div>
            <div class="card-body">
              @if (selectedBeneficiary?.senderName) {
                <div class="mb-2">
                  <strong>Name:</strong>
                  {{ selectedBeneficiary.senderName }}
                </div>
              }
              @if (selectedBeneficiary?.senderEmail) {
                <div class="mb-2">
                  <strong>Email:</strong>
                  {{ selectedBeneficiary.senderEmail }}
                </div>
              }
              @if (selectedBeneficiary?.senderDOB) {
                <div class="mb-2">
                  <strong>Date of Birth:</strong>
                  {{ formatDob(selectedBeneficiary.senderDOB, selectedBeneficiary.senderCountryDOBFormat) }}
                </div>
              }
              @if (selectedBeneficiary?.senderCountryName) {
                <div class="mb-2">
                  <strong>Country:</strong>
                  {{ selectedBeneficiary.senderCountryName }}
                </div>
              }
              <!-- citizenship country -->
              @if (selectedBeneficiary?.senderCitizenshipCountry) {
                <div class="mb-2">
                  <strong>Citizenship:</strong>
                  {{ selectedBeneficiary.senderCitizenshipCountry.displayName }}
                </div>
              }
            </div>
          </div>
        </div>
        <!-- Beneficiary Details -->
        <div class="col-md-6">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-header bg-light fw-bold">
              Beneficiary Details
            </div>
            <div class="card-body">
              @if (selectedBeneficiary.isBill && selectedBeneficiary.customerFields) {
                <div class="mb-2">
                  @for (entry of selectedBeneficiary.customerFields | keyvalue; track entry) {
                    <div>
                      <strong>{{ entry.key }}:</strong>
                      {{ entry.value }}
                    </div>
                  }
                </div>
              }
              @for (field of dynamicFieldsList; track field) {
                <div class="mb-2">
                  <strong>{{ field.key }}: </strong>
                  @if (field.value?.startsWith('http')) {
                    <img [src]="field.value" alt="{{ field.key }}" class="img-fluid" style="max-height: 40px;">
                  } @else {
                    {{ field.value }}
                  }
                  <ng-template #textValue>{{ field.value }}</ng-template>
                </div>
              }
              @if (selectedBeneficiary?.receiverCountryName) {
                <div class="mb-2">
                  <strong>Country:</strong>
                  {{ selectedBeneficiary.receiverCountryName }}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      <!-- AML Verification Section -->
      <div class="card mt-4 border-0 shadow-sm">
        <div class="card-header bg-light fw-bold">
          AML Verification (Tutelar)
        </div>
        <div class="card-body">
          <!-- Sender -->
          <div class="mb-4">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="fw-semibold text-secondary small text-uppercase">
                <i class="bi bi-person me-1"></i>Sender
              </span>
              @if (selectedBeneficiary?.senderValidation?.searchDate) {
                <span class="text-muted" style="font-size:0.75rem">
                  {{ selectedBeneficiary.senderValidation.searchDate | date:'medium' }}
                </span>
              }
            </div>
            @if (selectedBeneficiary?.senderValidation === null) {
              <div class="text-center py-3">
                <div class="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
                <span class="text-muted">Scanning...</span>
              </div>
            }
            @if (selectedBeneficiary?.senderValidation?.noResults) {
              <div class="alert alert-success py-2 mb-0">
                <i class="bi bi-shield-check me-2"></i>No sanctions or PEP matches found.
              </div>
            }
            @if (selectedBeneficiary?.senderValidation?.searchResults?.length > 0) {
              <div class="table-responsive">
                <table class="table table-bordered table-sm table-hover align-middle mb-0 small">
                  <thead class="table-light">
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Match Score</th>
                      <th>Risk Score</th>
                      <th>Nationality</th>
                      <th>Country</th>
                      <th>DOB</th>
                      <th>Tags</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (result of selectedBeneficiary.senderValidation.searchResults; track result) {
                      <tr
                        [ngClass]="result.scoreResults?.riskScore >= 70 ? 'table-danger' : result.scoreResults?.riskScore >= 40 ? 'table-warning' : ''">
                        <td class="fw-semibold">{{ result.caption }}</td>
                        <td><span class="badge bg-secondary text-capitalize">{{ result.sdnType }}</span></td>
                        <td class="fw-bold" [ngClass]="result.scoreResults?.matchScore >= 70 ? 'text-danger' : result.scoreResults?.matchScore >= 40 ? 'text-warning' : 'text-success'">
                          {{ result.scoreResults?.matchScore }}%
                        </td>
                        <td class="fw-bold" [ngClass]="result.scoreResults?.riskScore >= 70 ? 'text-danger' : result.scoreResults?.riskScore >= 40 ? 'text-warning' : 'text-success'">
                          {{ result.scoreResults?.riskScore }}%
                        </td>
                        <td>{{ result.nationality?.join(', ') || '—' }}</td>
                        <td>{{ result.country?.join(', ') || '—' }}</td>
                        <td>{{ result.birthDate?.join(', ') || '—' }}</td>
                        <td>
                          @for (tag of result.topicTags; track tag) {
                            <span class="badge bg-info text-dark me-1">{{ tag }}</span>
                          }
                          @if (!result.topicTags?.length) {
                            <span>—</span>
                          }
                        </td>
                        <td>
                          @if (result.decisionStatus) {
                            <span class="badge bg-warning text-dark">Action Taken</span>
                          }
                          @if (!result.decisionStatus) {
                            <span class="badge bg-light text-dark border">Clear</span>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
          <hr class="my-3">
          <!-- Receiver -->
          <div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="fw-semibold text-secondary small text-uppercase">
                <i class="bi bi-person-check me-1"></i>Receiver
              </span>
              @if (selectedBeneficiary?.receiverValidation?.searchDate) {
                <span class="text-muted" style="font-size:0.75rem">
                  {{ selectedBeneficiary.receiverValidation.searchDate | date:'medium' }}
                </span>
              }
            </div>
            @if (selectedBeneficiary?.receiverValidation === null) {
              <div class="text-center py-3">
                <div class="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
                <span class="text-muted">Scanning...</span>
              </div>
            }
            @if (selectedBeneficiary?.receiverValidation?.noResults) {
              <div class="alert alert-success py-2 mb-0">
                <i class="bi bi-shield-check me-2"></i>No sanctions or PEP matches found.
              </div>
            }
            @if (selectedBeneficiary?.receiverValidation?.searchResults?.length > 0) {
              <div class="table-responsive">
                <table class="table table-bordered table-sm table-hover align-middle mb-0 small">
                  <thead class="table-light">
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Match Score</th>
                      <th>Risk Score</th>
                      <th>Nationality</th>
                      <th>Country</th>
                      <th>DOB</th>
                      <th>Tags</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (result of selectedBeneficiary.receiverValidation.searchResults; track result) {
                      <tr
                        [ngClass]="result.scoreResults?.riskScore >= 70 ? 'table-danger' : result.scoreResults?.riskScore >= 40 ? 'table-warning' : ''">
                        <td class="fw-semibold">{{ result.caption }}</td>
                        <td><span class="badge bg-secondary text-capitalize">{{ result.sdnType }}</span></td>
                        <td class="fw-bold" [ngClass]="result.scoreResults?.matchScore >= 70 ? 'text-danger' : result.scoreResults?.matchScore >= 40 ? 'text-warning' : 'text-success'">
                          {{ result.scoreResults?.matchScore }}%
                        </td>
                        <td class="fw-bold" [ngClass]="result.scoreResults?.riskScore >= 70 ? 'text-danger' : result.scoreResults?.riskScore >= 40 ? 'text-warning' : 'text-success'">
                          {{ result.scoreResults?.riskScore }}%
                        </td>
                        <td>{{ result.nationality?.join(', ') || '—' }}</td>
                        <td>{{ result.country?.join(', ') || '—' }}</td>
                        <td>{{ result.birthDate?.join(', ') || '—' }}</td>
                        <td>
                          @for (tag of result.topicTags; track tag) {
                            <span class="badge bg-info text-dark me-1">{{ tag }}</span>
                          }
                          @if (!result.topicTags?.length) {
                            <span>—</span>
                          }
                        </td>
                        <td>
                          @if (result.decisionStatus) {
                            <span class="badge bg-warning text-dark">Action Taken</span>
                          }
                          @if (!result.decisionStatus) {
                            <span class="badge bg-light text-dark border">Clear</span>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="mb-2 mt-3">
        <strong>Status:</strong>
            <span class="badge ms-2" [ngClass]="selectedBeneficiary.status === 'Approved'
            ? 'bg-success'
            : selectedBeneficiary.status === 'Rejected'
            ? 'bg-danger'
            : 'bg-warning text-dark'">
          {{ selectedBeneficiary.status }}
        </span>
      </div>
      @if (selectedBeneficiary.rejectionReason) {
        <div class="mb-2 mt-2">
          <strong>Rejection Reason:</strong>
          <span class="ms-2">{{ selectedBeneficiary.rejectionReason }}</span>
        </div>
      }
      @if (selectedBeneficiary.status !== 'Approved' && selectedBeneficiary.status !== 'Rejected') {
        <div class="text-end">
          @if (selectedBeneficiary.status !== 'Approved' && selectedBeneficiary.status !== 'Rejected') {
            <div class="mb-2 text-start">
              <label for="rejectionReason" class="form-label">Rejection Reason</label>
              <textarea id="rejectionReason" class="form-control" rows="3" [(ngModel)]="rejectionReason"
              placeholder="Enter rejection reason"></textarea>
            </div>
          }
          <button class="btn btn-success me-2" (click)="onApprove(selectedBeneficiary, modal)">Approve</button>
          <button class="btn btn-danger" (click)="onReject(selectedBeneficiary, modal)" [disabled]="!rejectionReason.trim()">Reject</button>
        </div>
      }
    </div>
  }
</ng-template>
